<mat-fab-menu color="primary"
              direction="top"
              [fabButtons]="fabButtonsRandom"
              (onFabMenuItemSelected)="toggle($event)">
</mat-fab-menu>